<template>
    <template v-for="(row, i) in value.structure" :key="i">
        <div class="w-100">
            <ShowElement
                v-model="value.structure[i]"
                v-model:parent="value"
                :tabs="tabs"
                :position="i"
                :last="value.structure.length - 1"
                :up="up"
                @move="move"
                @insert="insert(i)"
                @delete="deleteFc(i)"
            />
        </div>
    </template>
</template>


<script>
import ShowElement from '@/components/calculations/ShowElement.vue';

export default {
    components: {
        ShowElement
    },
    props: {
        modelValue: {},
        tabs: {
            type: Number,
            required: false,
            default: 0
        },
        up: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {}
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
    },
    methods: {
        move: function (position, new_position) {
            var tmp = this.value.structure[new_position];
            this.value.structure[new_position] = this.value.structure[position]
            this.value.structure[position] = tmp;
        },
        insert: function (i) {
            if (i == 0) {
                return
            }
            this.value.structure[i - 1] = this.value.structure[i];
        },
        deleteFc: function (i) {
            this.value.structure.splice(i, 1);
        }
    }
}
</script>

<style lang="scss">
</style>